import React, { useState, useContext, useEffect } from 'react'
import ButtonizedInput from '../../atoms/ButtonizedInput/ButtonizedInput'
import Modal from '../../atoms/Modal/Modal'
import LoadMoreButton from '../../atoms/LoadMoreButton/LoadMoreButton'
import styles from './taggedMrSelector.module.scss'
import { getMRs } from '../../../services/api/mrService'
import { NotifierContext } from '../../../context/NotifierContext'

// Maintain local state for selected options (tagged MRs)
const TaggedMrSelector = ({ selectedTaggedMRs, setSelectedTaggedMRs }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState([])
  const [mrListData, setMrListData] = useState([])
  const [loading, setLoading] = useState(false)
  const [perPage] = useState(10)

  const { notifyError } = useContext(NotifierContext)

  useEffect(() => {
    setSelectedOptions(selectedTaggedMRs)
  }, [modalOpen])

  const handleButtonizedInputClick = () => {
    // Open the modal when the buttonized input is clicked
    setModalOpen(true)
    // Fetch the MR list when the modal opens only if mrListData is empty
    if (mrListData.length === 0) {
      // Fetch the MR list from the API
      fetchMRs(1)
    }
  }

  const fetchMRs = async (pageNumber) => {
    try {
      setLoading(true)
      const response = await getMRs('', pageNumber, perPage)
      const { MRList } = response.data
      pageNumber === 1 && setMrListData(MRList)
      pageNumber > 1 && setMrListData((prevData) => [...prevData, ...MRList])
    } catch (error) {
      notifyError(error)
    } finally {
      setLoading(false)
    }
  }

  const handleLoadMore = () => {
    const nextPage = Math.floor(mrListData.length / 10) + 1
    fetchMRs(nextPage)
  }

  const handleSelectedOptions = (mr) => {
    const isSelected = selectedOptions.some((option) => option.label === mr.userInfo?.mrCode)

    if (isSelected) {
      // If the MR is already selected, remove it from the selected options
      setSelectedOptions((prevOptions) => prevOptions.filter((option) => option.label !== mr.userInfo?.mrCode))
    } else {
      // If the MR is not selected, add it to the selected options
      setSelectedOptions((prevOptions) => [...prevOptions, { label: mr.userInfo?.mrCode, value: mr.cognitoDetails?.sub }])
    }
  }

  const handleOkAction = () => {
    // Close the modal and set the selected tagged MRs in the parent component
    // Format the selected options to match the expected structure
    const formattedOptions = selectedOptions.map((option) => ({
      label: option.label,
      value: option.value
    }))
    setSelectedTaggedMRs(formattedOptions)
    setModalOpen(false)
  }

  return (
    <div>
      <ButtonizedInput
        label='Tagged MRs'
        placeholder='Select MRs'
        onClick={handleButtonizedInputClick}
        value={selectedTaggedMRs.map((option) => option.label)}
      />
      <Modal
        title='Select MRs associated with this TC'
        visible={modalOpen}
        onModalClose={() => setModalOpen(false)}
        okAction={handleOkAction}
      >
        {loading
          ? <div>Loading...</div>
          : (mrListData.length > 0
              ? mrListData.map((mr, index) => (
                <label className={styles.label} key={mr.userInfo?.mrCode}>
                  <input
                    className={styles.checkbox}
                    type='checkbox'
                    checked={selectedOptions.some((option) => option.label === mr.userInfo?.mrCode)}
                    onChange={(e) => handleSelectedOptions(mr)}
                  />
                  {mr.userInfo?.mrCode ?? '-----'}
                </label>
              ))
              : <div className='text-center'>No MRs found</div>
            )}
        {mrListData.length <= perPage && (
          <div className='d-flex justify-content-center'>
            <LoadMoreButton onClick={handleLoadMore} loading={loading} />
          </div>
        )}

      </Modal>
    </div>
  )
}

export default TaggedMrSelector
